import * as api from "app/api/userApi";
import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { TimezoneHelper } from "app/helpers/timezoneHelper";
import isPublicView from "app/utils/publicViewUtils";
import cloneDeep from "lodash/cloneDeep";
import * as apiUser from "../../api/userApi";
const UserModel = {
  state: {
    user: {
      currencyCode: "GBP",
      balance: {
        balance: 0,
        exposure: 0,
        credit: 0,
        freeFunds: 0,
      },
      verifiedStatus: "",
      lastLogin: "",
      lastLoginIpAddress: "",
    },
    isUserLoading: true,
    timezone: {
      offset: 0,
      value: "GMT",
      label: "GMT",
      name: "GMT",
    },
  },
  reducers: {
    // start loading
    setUserRequest(state: Record<string, any>): any {
      return { ...state, isUserLoading: true };
    },
    // Set the user
    setUser(state: Record<string, any>, payload: any): any {
      const user = cloneDeep(state.user);
      const params = { ...state, user: user, isUserLoading: false };

      if (SessionHelper.isAsianRouteAndSessionView()) {
        let timezoneCode = payload.preferences && payload.preferences.timezone;
        const timezoneObj = TimezoneHelper.getTimezoneObject(timezoneCode);

        if (timezoneObj) {
          params.timezone = {
            offset: timezoneObj.offset,
            value: timezoneObj.value,
            label: timezoneObj.label,
            name: timezoneObj.name,
          };
        }
      }

      // Merge old and new user
      Object.assign(user, payload);
      return params;
    },
  },

  effects: dispatch => ({
    async loadUser(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      this.setUserRequest();

      api.fetchUser().then(resp => {
        // replace user data returned by API with data stored locally on UI
        if (isPublicView()) {
          let preferences = {
            ...resp.preferences,
            uiViewMode: localStorage.getItem("sessionView"),
            oddsType:
              SessionHelper.getOddsType() === null
                ? resp.preferences.oddsType
                : SessionHelper.getOddsType(),

            language:
              LanguageSelectionHelper.checkCookieLanguageSelected() ===
              undefined
                ? resp.preferences.language
                : LanguageSelectionHelper.checkCookieLanguageSelected(),
          };
          let publicViewPreferences = { ...resp, preferences: preferences };

          this.setUser(publicViewPreferences);
          SessionHelper.setOddsType(publicViewPreferences.preferences.oddsType);
          LanguageSelectionHelper.saveLanguageToCookie(
            publicViewPreferences.preferences.language
          );
        } else {
          this.setUser(resp);
          SessionHelper.setOddsType(resp.preferences.oddsType);
        }
      });
    },

    // Update user timezone preference
    async updateTimezone(timezone: string, rootState: Record<string, any>) {
      this.setUserRequest();
      api
        .updateTimezone(timezone, rootState.userModel.user)
        .then(resp => {
          this.setUser(resp);
        })
        .catch(error => {
          console.log(error);
        });
    },
    /* update user preference */
    async setUserPreference(payload: string, rootState: Record<string, any>) {
      const user = cloneDeep(rootState.userModel.user);
      const userId = user.userId;
      const accountId = user.accountId;
      // Got an error when sending just one preference so sending all preferences
      // with the updated preference
      const preferences = cloneDeep(rootState.userModel.user.preferences);
      apiUser
        .updatePreference(
          userId,
          accountId,
          Object.assign(preferences, payload)
        )
        .then(resp => {
          dispatch.userModel.setUser(resp);
        })
        .catch(error => {
          console.log("updatePreferences error", error);
        });
    },
  }),
};
export default UserModel;
